import { api } from "../config";

export const apiCallsProfile = {
    Actions: {
        GetDevices: async (filters) => {
            try {
                const fromDateTime = filters.fromDate.hour(filters.fromTime.hour()).minute(filters.fromTime.minute() || 0).second(filters.fromTime.second() || 0);
                const toDateTime = filters.toDate.hour(filters.toTime.hour()).minute(filters.toTime.minute() || 0).second(filters.toTime.second() || 0);
                const fromDateFormat = fromDateTime.toISOString();
                const toDateFormat = toDateTime.toISOString();
                const response = await api.get("Profile", {
                    params: {
                        Active: filters.deviceStates.active, 
                        Dimmed: filters.deviceStates.dim, 
                        NotResponse: filters.deviceStates.error, 
                        Closed: filters.deviceStates.off, 
                        SuccessConnected: filters.deviceStates.selected, 
                        HasError: filters.deviceStates.deverror,
                        DateFrom: fromDateFormat, 
                        DateTo: toDateFormat,
                        TimeFrom: filters.fromTime.hour(),
                        TimeTo: filters.toTime.hour()
                    }
                });
                return response.data;
            } catch (error) {
                console.error("API Error:", error.response?.data || error.message);
                throw error;
            }
        },

        SendToSelectedPolygon: async (dimlevel, selectedDevices) => {
            try {

                const response = await api.post("Profile/send-polygon", {
                    dimlevel: dimlevel,
                    selectedDevices: selectedDevices,
                });
                return response;
            } catch (error) {
                console.error("API Error:", error);
            }
        },

        Port25 : async (deviceId) => {
            try {
                const response = await api.get(`Profile/device-info/${deviceId}`);
                return response.data;
                
            } catch (error) {
                console.error("API Error ", error);
            }
        },

        SendToSelected: async (name, dimlevel) => {
            try {
                const response = await api.post("Profile/send-selected", {
                    name: name,
                    dimlevel: dimlevel,
                })

                return response;

            } catch (error) {
                console.error("API Error ", error);
                throw error
            }
        },

        RevertToSelected: async (name) => {
            try {
                const response = await api.post("Profile/revert-selected", {
                    name: name,
                })

                return response;
            } catch (error) {
                console.error("API Error ", error);
                throw error
            }
        },

        GetSiteParameters: async (deviceId) => {
            try {
                const response = await api.get(`Profile/site-info/${deviceId}`, {
                    id: deviceId
                });
                return response.data.data;
            } catch (error) {
                console.error("API Error: ", error);
            }
        }

    }
}